import { useEffect, useState } from 'react';
import { getIqEntitlement } from '../../api/iq-client';
import { IqEntitlement } from '../../interfaces/iq-interfaces';

// POLARITY INVERSION vs use-unit-allowance: not-loaded reads as OFF. Showing an
// aurora AI surface that then 403s is worse than showing nothing, and it burns
// the one piece of visual vocabulary reserved for AI. `enabled` is not optional
// plumbing: without it this fires GET /api/iq/entitlement for every authenticated
// user, including residents on routes where /api/iq/* 403s behind the staff gate.
export const useIqEntitlement = (opts?: {
  enabled?: boolean;
}): { state: IqEntitlement | null; loading: boolean } => {
  const enabled = opts?.enabled !== false;
  const [state, setState] = useState<IqEntitlement | null>(null);
  const [loading, setLoading] = useState<boolean>(enabled);

  useEffect(() => {
    if (!enabled) {
      setState(null);
      setLoading(false);

      return;
    }
    let alive = true;
    setLoading(true);
    getIqEntitlement()
      .then(s => {
        if (alive) {
          setState(s);
          setLoading(false);
        }
      })
      .catch(() => {
        // Fail closed: any error means IQ is off. Never optimistic.
        if (alive) {
          setState(null);
          setLoading(false);
        }
      });

    return () => {
      alive = false;
    };
  }, [enabled]);

  return { state, loading };
};
